import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/imgs/loda_food.jpg'
import _imports_1 from '../assets/imgs/qrCode.png'
import _imports_2 from '../assets/imgs/ios_store.png'
import _imports_3 from '../assets/imgs/google_play.png'
import _imports_4 from '../assets/imgs/huawei.png'
import _imports_5 from '../assets/imgs/ButtonDirect.png'


const _withScopeId = n => (_pushScopeId("data-v-7d9ae368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loda_food" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loda_food",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "qrCode",
  src: _imports_1
}, null, -1))
const _hoisted_4 = { class: "ApplicationMarket" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div data-v-7d9ae368><a href=\"https://apps.apple.com/cn/app/id1014885268\" target=\"_balank\" data-v-7d9ae368><img alt=\"Download LODA iOS APP\" title=\"Download LODA iOS APP\" src=\"" + _imports_2 + "\" data-v-7d9ae368></a><a href=\"https://play.google.com/store/apps/details?id=com.anhe.loda\" target=\"_balank\" data-v-7d9ae368><img alt=\"Download LODA Android APP\" title=\"Download LODA Android APP From Google Play\" src=\"" + _imports_3 + "\" data-v-7d9ae368></a><a href=\"https://appgallery.huawei.com/#/app/C102032523\" target=\"_balank\" data-v-7d9ae368><img alt=\"Download LODA APP\" title=\"Download LODA APP From Huawei\" src=\"" + _imports_4 + "\" data-v-7d9ae368></a><a href=\"https://www.loda.com.kh/app/loda.apk\" target=\"_balank\" data-v-7d9ae368><img alt=\"Download LODA Android APP\" title=\"Download LODA Android APP\" src=\"" + _imports_5 + "\" data-v-7d9ae368></a></div>", 1)

import { ref, reactive, onMounted, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'loda_food',
  setup(__props) {

onMounted(() => { })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("LODA FOOD")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('美味佳肴、超市便利')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('随时随点随到 尽在LODA APP')), 1),
      _hoisted_5
    ])
  ]))
}
}

})